import { render, staticRenderFns } from "./proxyShopList.vue?vue&type=template&id=3c337d96"
import script from "./proxyShopList.vue?vue&type=script&lang=js"
export * from "./proxyShopList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports